import lang from './lang';

const translations = {
  en: {
    comingSoon: '(COMING SOON)',
    menuButton: 'META-PARADE\nGALLERY',
    gallery: 'GALLERY',
  },
  tc: {
    comingSoon: '(敬請期待)',
    menuButton: '探索藝術品',
    gallery: '畫廊',
  },
  sc: {
    comingSoon: '(敬请期待)',
    menuButton: '探索艺术品',
    gallery: '画廊',
  },
};

export default translations[lang];